import { render } from "./LinkLogout.vue?vue&type=template&id=04ba542c"
import script from "./LinkLogout.vue?vue&type=script&lang=js"
export * from "./LinkLogout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__